module.exports = __webpack_public_path__ + "img/school.3828318e.png";